<template>
    <d-container fluid class="main-content-container px-4 pb-4">
      <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage">
      </loading>
      <!-- Page Header -->
      <d-row no-gutters class="page-header py-4">
        <!-- Page Header - Page Title -->
        <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
          <h3 class="page-title">Domain Performance</h3>
        </d-col>
      </d-row>

      <d-row no-gutters class="dataTables_wrapper">
          <d-form inline>
          </d-form>
      </d-row>

      <d-row>
          <d-col lg="12" class="mb-4">

            <d-card class="card-small">

              <!-- Form Example -->
              <d-card-header class="border-bottom">
                <d-row>
                    <d-col sm="3" xs="12" class="mb-2">
                        <h6 class="m-0">Filters</h6>
                    </d-col>
                    <d-col sm="9" xs="12" class="d-flex justify-content-center justify-content-md-end">
                        <export-performance
                            :start-date="dateRange.from"
                            :end-date="dateRange.to"
                            :type="type"
                            :page="page"
                            @exportPerformance="onExportPerformance"
                        />
                    </d-col>
                </d-row>
              </d-card-header>

              <d-list-group flush>
                <d-list-group-item class="pl-3 pr-3 pt-4 pt-0">
                    <d-row>
                      <d-col>
                        <d-form id="performanceForm" @submit.prevent="getPerformance('domain', 1, true)">
                            <d-form-row>
                              <d-col lg="6" class="form-group performance-form">
                                  <d-input-group class="date-range">
                                    <calendar-picker :date-range="dateRange"/>
                                  </d-input-group>
                              </d-col>
                              <d-col lg="6" class="form-group performance-form">
                                  <d-input-group>
                                    <input value="Apply filter" type="submit" class="btn mr-1 btn-primary">
                                    <input type="button" value="Reset filter" @click="resetFilter('domain')" class="btn mr-1 btn-secondary">
                                  </d-input-group>
                              </d-col>
                            </d-form-row>
                        </d-form>
                      </d-col>
                    </d-row>
                </d-list-group-item>
              </d-list-group>

            </d-card>
          </d-col>
        </d-row>

    <d-card class="card-small">
        <v-client-table v-if="!isPerformanceLoading" class="dataTables_wrapper" :data="Performances" :columns="columns" :options="clientTableOptions">
            <span slot="media" slot-scope="props">
                {{ props.row.name }}
            </span>
            <span slot="approvedNumber" slot-scope="props">
                {{ props.row.approvedNumber }}
            </span>
            <span slot="approved" slot-scope="props">
                €{{ props.row.approved | toDec }}
            </span>
            <span slot="pendingNumber" slot-scope="props">
                {{ props.row.pendingNumber }}
            </span>
            <span slot="open" slot-scope="props">
                €{{ props.row.open  | toDec }}
            </span>
            <span slot="disapprovedNumber" slot-scope="props">
                {{ props.row.disapprovedNumber }}
            </span>
            <span slot="disapproved" slot-scope="props">
                €{{ props.row.disapproved | toDec }}
            </span>
            <span slot="number" slot-scope="props">
                {{ props.row.number }}
            </span>
            <span slot="total" slot-scope="props">
                €{{ props.row.total | toDec }}
            </span>
          </v-client-table>
          <d-container class="d-flex justify-content-center" fluid v-else>
            <b-spinner label="Spinning"></b-spinner>
          </d-container>
          <pagination :options="paginationOptions" :records="records" v-model="page" :per-page="25" @paginate="getPerformance('domain', page, false)" />
    </d-card>
    </d-container>
  </template>

<script>
import performance from '@/mixins/performance';
import Loading from 'vue-loading-overlay';
import ExportPerformance from '@/components/common/ExportPerformance.vue';
import CalendarPicker from '@/components/form/calendarPicker.vue';

export default {
    mixins: [performance],

    components: {
        Loading,
        CalendarPicker,
        ExportPerformance
    },

    data() {
        return {
            isPerformanceLoading: true,
            isLoading: false,
            fullPage: true,
            page: 1,
            records: 0,
            type: 'domain',
            Websites: [],
            WebsiteFilters: [],
            Performances: [],

            paginationOptions: {
                chunk: 5
            },

            dateRange: {
                from: '',
                to: '',
            },

            columns: ['media', 'approvedNumber', 'approved', 'pendingNumber', 'open', 'disapprovedNumber', 'disapproved', 'number', 'total'],

            /**
             * Vue Tables Configuration Options
             * @see https://github.com/matfish2/vue-tables-2
            */
            clientTableOptions: {
                perPage: 25,
                childRowTogglerFirst: false,
                recordsPerPage: [25, 50, 100],
                skin: 'transaction-history table dataTable',
                texts: {
                    limit: 'Show',
                    count: ''
                },
                pagination: { show: false },
                columnsDisplay: {
                    approved: 'desktop',
                    approvedNumber: 'desktop',
                    pendingNumber: 'desktop',
                    open: 'desktop',
                    disapprovedNumber: 'desktop',
                    disapproved: 'desktop',
                },
                columnsClasses: {
                    media: 'advertiser',
                    approvedNumber: 'approved',
                    approved: 'approved',
                    pendingNumber: 'pending',
                    disapprovedNumber: 'disapproved',
                    disapproved: 'disapproved',
                    open: 'pending',
                },
                headings: {
                    id: '#',
                    media: 'MEDIA',
                    approvedNumber: '#',
                    approved: 'APPROVED',
                    pendingNumber: '#',
                    open: 'PENDING',
                    disapprovedNumber: '#',
                    disapproved: 'DISAPPROVED',
                    number: '#',
                    total: 'TOTAL',
                },
            },
        };
    },
};
</script>
